// extracted by mini-css-extract-plugin
module.exports = {"left":"styles_left__VDXd2","right":"styles_right__O9K8v","counter":"styles_counter__geWxn"};